import CardContainer from "../CardContainer/CardContainer";
import Img from "../Img/Img";
import CSS from "./static/css/MainListItemCard.module.css";

const MainListItemCard = (
    {
        img_src,
        children,
        onClick,
        thumbnail_no_padding,
        img_object_fit,
    }:{
        img_src: string;
        children?: React.ReactNode;
        onClick?: React.MouseEventHandler<HTMLDivElement>;
        thumbnail_no_padding?: boolean;
        img_object_fit?: "cover" | "contain";
    }
) => {
    return(
        <CardContainer
            class_name_list={[CSS.l_MainListItemCard_main]}
            onClick={onClick}
        >
            <CardContainer
                class_name_list={[CSS.l_MainListItemCard__img_container]}
                preset={"thumbnail_img"}
                noPadding={thumbnail_no_padding}
                noStyle={true}
            >
                <Img
                    src={img_src}
                    object_fit={img_object_fit || "contain"}
                />
            </CardContainer>
            {
                children
                &&  <div className={CSS.l_MainListItemCard__children_container}>
                        {children}
                    </div>
            }
        </CardContainer>
    )
}

export default MainListItemCard;
